import React from 'react';
import { TableData } from '../InternalIntermediate';
import { SubmitHandler, useFieldArray, useForm } from 'react-hook-form';
import { Button, Spinner } from '../../../../components';
import { useMutation } from '@apollo/client';
import { UPDATE_INTERMEDIATE_MITIGATION } from '../../queries';

interface InternalIntermediateFormProps {
  data?: TableData;
  location: string;
  division: string;
  onCancel: () => void;
}

export function InternalIntermediateForm({
  data,
  division,
  location,
  onCancel,
}: InternalIntermediateFormProps) {
  const [UpdateIntermediateMitigation, { loading, error }] = useMutation(
    UPDATE_INTERMEDIATE_MITIGATION,
    {
      refetchQueries: ['GetIntermediateMitigationMatrix'],
    },
  );
  const { register, control, handleSubmit } = useForm({
    defaultValues: data,
  });
  const { fields } = useFieldArray({
    control,
    name: 'locations',
  });

  if (loading) return <Spinner />;
  if (error) return <>Error! {error.message}</>;

  const onFinish: SubmitHandler<TableData> = async (values) => {
    let response;

    values?.locations?.map(async (item) => {
      const delay = parseFloat(item.delay.toString());
      const percentage = parseFloat(item.percentage.toString());

      try {
        response = await UpdateIntermediateMitigation({
          variables: {
            data: {
              data: [
                {
                  delay,
                  percentage,
                  locationAux: { uuid: item.uuid },
                  vendor: { uuid: '' },
                },
              ],
              division: { uuid: division },
              location: { uuid: location },
              intermediateType: 'Internal',
              intermediate: { uuid: values.uuid },
            },
          },
        });
        if (response?.data) onCancel();
      } catch (e: any) {
        console.log(e.message);
      }
    });
  };

  return (
    <form
      className="  w-full flex flex-col flex-nowrap mt-2"
      onSubmit={handleSubmit(onFinish)}
    >
      <h1 className="  font-bold text-lg tracking-widest">
        {data?.locationSupported}
      </h1>
      <div className="w-full relative my-4">
        <span className="  font-bold text-sm text-primary-200 absolute right-60">
          Mitigation
        </span>
        <span className="  font-bold text-sm text-primary-200 absolute right-12">
          Ramp-up
        </span>
      </div>
      {data?.locations?.map((location, index) => (
        <div className="inline-flex flex-row flex-nowrap items-center my-2 justify-between">
          <label
            className="font-semibold text-primary-200 text-sm"
            htmlFor={location.uuid}
          >
            {location.locationName}
          </label>
          <div>
            <span className="mx-4 w-28 border rounded-lg text-right text-primary-200 font-normal text-sm px-2 py-2 h-auto">
              <input
                placeholder="100 %"
                className="w-24 bg-transparent border-none text-right text-primary-200 font-normal text-sm focus:outline-none focus:ring-0"
                type="number"
                step={0.01}
                id={location.uuid}
                defaultValue={location.percentage}
                {...register(`locations.${index}.percentage`, {
                  required: true,
                  min: {
                    value: 0,
                    message: 'Percentage must be greater than 0.',
                  },
                  max: {
                    value: 100,
                    message: 'Percentage must be less than 100.',
                  },
                })}
              />
              %
            </span>
            <span className="mx-4 w-28 border rounded-lg text-right text-primary-200 font-normal text-sm px-2 py-2 h-auto">
              <input
                placeholder="5 mths"
                className="w-24 bg-transparent border-none text-right text-primary-200 font-normal text-sm focus:outline-none focus:ring-0"
                type="number"
                step={0.01}
                id={location.uuid}
                defaultValue={location.delay}
                {...register(`locations.${index}.delay`, {
                  required: true,
                  min: {
                    value: 0,
                    message: 'Delay must be greater than 0.',
                  },
                })}
              />
              mths
            </span>
          </div>
        </div>
      ))}
      <div className="inline-flex flex-row justify-center mt-6">
        <Button type={'default'} htmlType={'submit'}>
          Save
        </Button>
      </div>
    </form>
  );
}
